const AcademicTermsTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 100 },
    { id: 'name', labelAr: 'اسم الفصل', labelEn: 'Term Name' },
    { id: 'academic_year_name', labelAr: 'السنة الدراسية', labelEn: 'Academic Year' },
    { id: 'school_name', labelAr: 'المدرسة', labelEn: 'School', width: 140 },
    { id: 'start_date', labelAr: 'تاريخ البداية', labelEn: 'Start Date', width: 130 },
    { id: 'end_date', labelAr: 'تاريخ النهاية', labelEn: 'End Date', width: 130 },
    { id: 'is_current', labelAr: 'الحالي', labelEn: 'Current', width: 100 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 100 },
];

export default AcademicTermsTableColumns;
